import { createContext, useMemo } from 'react'

import { Outlet } from 'react-router'

import { useDateRangeContext } from '@/components/provider/date-range-provider.tsx'
import { AccessControlGuard } from '@/modules/accounts/state/AccessControlGuard.tsx'
import { CreatorFeatures } from '@/modules/accounts/types.ts'
import { usePpvTrackingQuery } from '@/modules/tracking/ppv/hooks/usePpvTrackingQuery.tsx'

import type { PpvTrackingContextState } from '../types'

export const PpvTrackingContext = createContext({} as PpvTrackingContextState)

export const PpvTrackingProvider = () => {
  const { date, setDate } = useDateRangeContext()
  const {
    data: allCategories,
    isFetching,
    isIdle,
    refetch,
  } = usePpvTrackingQuery({
    date,
  })

  const values: PpvTrackingContextState = useMemo(
    () => ({
      allCategories,
      date,
      setDate,
      isFetching: isFetching || isIdle,
      refetch,
    }),
    [allCategories, date, setDate, isFetching, isIdle, refetch],
  )

  return (
    <AccessControlGuard
      featureDisplayName="PPV Tracking"
      creatorFeature={CreatorFeatures.script_tracking}
    >
      <PpvTrackingContext.Provider value={values}>
        <Outlet />
      </PpvTrackingContext.Provider>
    </AccessControlGuard>
  )
}
